<template>
  <div class="user-message">
    <div class="titles-right font-style">我的收藏</div>
    <div class="flex f-jcenter">
      <div
        class="ma-r-20 c-pointer pa-b-5"
        @click="
          tabIndex = 0;
          switType();
        "
        :class="tabIndex == 0 ? 'tab-active' : ''"
      >
        收藏资讯
      </div>
      <div
        class="ma-l-20 c-pointer pa-b-5"
        @click="
          tabIndex = 1;
          switType();
        "
        :class="tabIndex == 1 ? 'tab-active' : ''"
      >
        收藏方案
      </div>
    </div>
    <div class="" v-if="tabIndex==0">
      <div
        class="height302 list-item"
        v-for="(item, index) in newsList"
        :key="index"
        @click="toDetail(item.Id)"
      >
      <div class="flex f-between ma-t-20">
        <div class="flex flex-direction f-between">
          <div>{{item.Name}}</div>
          <div class="c-8a"><i class="iconfont icon-shijian"></i> {{item.ReleaseTime}}</div>
        </div>
        <div class="width30 pa-r-20" v-if="item.Image!=''">
          <img :src="item.Image" alt="" srcset="" class="width100 height100 b-r-8">
        </div>
      </div>
      </div>
    </div>
    <div class="flex f-center f-wrap ma-t-40 " v-if="tabIndex==1">
      <div
        class="boxs ma-t-30  ma-r-30"
        v-for="(item, index) in dataList"
        :key="index"
        @click="toDetail(item.Id)"
      >
        <img :src="item.Image" class="img" />

        <div class="t-omit-2 ma-t-10 pa-lr-10 fon-14 weight500 height40">
          {{ item.Name }}
        </div>
        <div class="c-8a ma-t-12 pa-lr-10 fon-12 flex f-between">
          {{ item.ReleaseTime }}
        </div>
      </div>
    </div>

    <div v-if="(tabIndex==0 && newsList.length==0) || (tabIndex==1 && dataList.length==0)" class="pa-t-100">
      <Empty></Empty>
    </div>

    <div class="t-center ma-t-20">
        <el-pagination
          @current-change="handleCurrentChange"
          :hide-on-single-page="true"
          :current-page.sync="queryList.pageIndex"
          :page-size="queryList.pageSize"
          layout="prev, pager, next, jumper"
          :total="totals"
        ></el-pagination>
      </div>
  </div>
</template>

<script>
import { NewsCollection, getDatumCollectionList } from "../api";
export default {
  name: "mycollect",
  data() {
    return {
      dataList: [],
      newsList: [],
      tabIndex: 0, //0 =》资讯收藏，1=》方案收藏
      queryList: {
        pageIndex: 1,
        pageSize: 10,
        source: "web",
      },
      totals: 0,
    };
  },
  mounted() {
    this.loadDataList();
  },
  methods: {
      // 当前页改变时触发
    handleCurrentChange(e) {
      this.queryList.pageIndex = e;
      this.loadDataList();
    },
    loadDataList() {
      if (this.tabIndex == 0) {
        NewsCollection(this.queryList).then((res) => {
          this.newsList = res.data.Data.List;
          this.totals = res.data.Data.TotalCount;
        });
      } else {
        getDatumCollectionList(this.queryList).then((res) => {
          this.dataList = res.data.Data.List;
          this.totals = res.data.Data.TotalCount;
        });
      }
    },
    //类型切换
    switType(){
      this.queryList.pageIndex=1;
      this.loadDataList()
    },
    //查看详情
    toDetail(id) {
      if (this.tabIndex == 0) {
        this.$router.push({
          path: '/Study-detail',
          query: { id: id },
        });
      }else{
          this.$router.push({
            path: "/read",
            query:{id:id}
          });
      }
    },
  },
};
</script>

<style  lang="scss" scoped>
.boxs{
  width: 29%;
  height: 240px;
  border: 1px solid #eee;
  .img{
    width: 100%;
    height: 160px;
    object-fit: cover;
  }
}
.pa-b-5{
  padding-bottom: 5px;
}
.img_263{
  object-fit: cover;
}
.list-item{
  cursor: pointer;
}
.list-item:not(:last-child){
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}
.titles-right:before {
  content: "|";
  display: inline-block;
  width: 4px;
  height: 19px;
  background: #234775;
  color: #234775;
  border-radius: 2px;
  margin-right: 8px;
}
.width920px {
  width: 920px;
}
.font-style {
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
}
.tab-active {
  border-bottom: 2px solid #234775;
}
</style>